export const LOGIN_NOT_FOUND = "login_not_found";
export const PASSWORD_INCORRECT = "password_incorrect";
export const USER_BLOCKED = "user_blocked";
export const LOGIN_AND_PASSWORD_REQUIRED = "login_and_password_required";
export const INTERNAL_ERROR = "internal_error";
export const UNAUTHORIZED = "unauthorized";
export const FORBIDDEN = "forbidden";
export const BAD_REQUEST = "bad_request";
export const SYSTEMROLE_CANT_BE_REMOV = "systemrole_cant_be_remov";
export const NOT_FOUND = "not_found";
export const SYSTEMROLE_CANT_BE_CHANGED = "systemrole_cant_be_changed";
export const USER_NOT_FOUND = "user_not_found";
export const EMAIL_CANT_BE_CHANGED = "email_cant_be_changed";
export const BAD_PASSWORD = "bad_password";

export const DVR_OR_CAMERA_NOT_FOUND = "dvr_or_camera_not_found";

export const MANUAL_DISABLED = "manual_disabled";

export const USERNAME_REQUIRED = "username_required";
export const PASSWORD_REQUIRED = "password_required";
export const EMAIL_REQUIRED = "email_required";
export const USERNAME_EXISTS = "username_exists";
export const USERNAME_TOO_SHORT =
  "username must be longer than or equal to 3 characters";

export const EMAIL_EXISTS = "email_exists";

export const NO_VEHICLE_FOUND = "no_vehicle_found";

export const BRANCH_NAME_USED = "branch_name_used";

export const apiErrors: { [key: string]: string } = {
  [LOGIN_NOT_FOUND]: "Логин не найден",
  [PASSWORD_INCORRECT]: "Неверный пароль",
  [USER_BLOCKED]: "Пользователь заблокирован",
  [LOGIN_AND_PASSWORD_REQUIRED]: "Укажите логин и пароль",
  [INTERNAL_ERROR]: "Ошибка сервера",
  [UNAUTHORIZED]: "Пользователь не авторизован",
  [FORBIDDEN]: "Доступ запрещен",
  [BAD_REQUEST]: "Неверный запрос",
  [USERNAME_REQUIRED]: "Требуется имя пользователя",
  [PASSWORD_REQUIRED]: "Требуется пароль",
  [EMAIL_REQUIRED]: "Требуется email",
  [USERNAME_EXISTS]: "Такое имя пользователя уже существует",
  [EMAIL_EXISTS]: "Такой email уже существует",
  [SYSTEMROLE_CANT_BE_REMOV]: "Системную роль нельзя удалить",
  [NOT_FOUND]: "Не найдено",
  [DVR_OR_CAMERA_NOT_FOUND]: "На ТС не установлены камеры или видеорегистратор",
  [SYSTEMROLE_CANT_BE_CHANGED]: "Системную роль нельзя изменить",
  [USER_NOT_FOUND]: "Пользователь не найден",
  [EMAIL_CANT_BE_CHANGED]: "Email нельзя изменить",
  [MANUAL_DISABLED]: "Нельзя удалить вручную",
  [NO_VEHICLE_FOUND]: "Ни один автомобиль не подходит под критерии заявки",
  [BAD_PASSWORD]:
    "Пароль должен быть длиной не менее 6-ти символов и состоять из букв и цифр",
  [BRANCH_NAME_USED]: "Название филиала уже используется",
  [USERNAME_TOO_SHORT]: "Имя пользователя должно быть не короче трех символов"
};
